module.exports = __webpack_public_path__ + "static/Bäckerbild 2-fd49ee3095141b34368efd64e606443b.jpg";